<template>
  <Wrapper>
    <WithSidebar data-cy="team-page">
      <Ad
        placement="content-top"
        :pos="1"
      />

      <Debug
        :label="`team#${currentTeamId}`"
        :data="team"
      />
      <Debug
        label="apiParams"
        :data="apiParams"
      />

      <h3
        v-if="contentLoaded"
        class="title"
      >
        {{ metaTitle() }}
      </h3>

      <template
        v-if="contentLoaded && team.gamesCount === 0"
      >
        <no-games-warning />
      </template>

      <div class="tw-flex tw-flex-wrap overview-stat-info">
        <div class="tw-order-2 tw-w-full lg:tw-w-4/12 lg:pl-4">
          <div class="overview-info">
            <TeamOverview
              v-if="contentLoaded"
              :team="team"
              :team-liked="teamLiked"
            />
          </div>
        </div>
        <div
          v-if="contentLoaded"
          class="tw-order-1 tw-w-full lg:tw-w-8/12 team-statistic"
        >
          <ChartClient
            v-if="contentLoaded"
            :chart-data="team.chart"
            type="teamCoteLine"
          />
        </div>
      </div>

      <b-tabs
        v-model="tabIndex"
        @input="tabInput"
      >
        <b-tab
          :active="!$route.hash || $route.hash === '#teams'"
          :title="`${$i18n.t('JSON.league-rankings')}`"
          @click="tabClicked('#teams')"
        >
          <TableServer
            v-if="contentLoaded"
            type="team"
            :api-params="apiParams"
          />
        </b-tab>
        <b-tab
          :active="$route.hash === '#games'"
          :title="`${$i18n.t('JSON.games-played')}`"
          @click="tabClicked('#games')"
        >
          <div class="tw-w-full tw-p-4 tw-bg-red-50">
            <b-form-checkbox
              v-model="completedGamesOnly"
              value="1"
              unchecked-value="0"
            >
              {{ $t('JSON.completed-games-only') | ucfirst }}
            </b-form-checkbox>
          </div>

          <TableServer
            v-if="contentLoaded"
            type="game"
            :api-params="apiParams"
          />
        </b-tab>
      </b-tabs>
    </WithSidebar>
  </Wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { sync } from 'vuex-pathify';

import tabHelpers from '@/mixins/helpers/tab-helpers';

import store from '@/vuex/store';

export default {

  components: {
    ChartClient: () => import(/* webpackChunkName: "components--charts" */ '@/components/charts/ChartClient'),
    TeamOverview: () => import(/* webpackChunkName: "page--Team" */ '@/components/overview/TeamOverview'),
  },

  mixins: [
    tabHelpers, //
  ],

  beforeRouteEnter: (to, from, next) => {
    const teamId = parseInt(to.params.u_team.split(/[-]+/g)[1], 10);
    const metaUrl = `/api/v1/meta/teams/${teamId}?lang=${store.state.lang.lang}`;

    axios
      .get(metaUrl)
      .then((response) => {
        store.dispatch('meta/updateMeta', response.data);
        next();
      })
      .catch(() => {
        next('/');
      });
  },

  beforeRouteUpdate: (to, from, next) => {
    const teamId = parseInt(to.params.u_team.split(/[-]+/g)[1], 10);
    const metaUrl = `/api/v1/meta/teams/${teamId}?lang=${store.state.lang.lang}`;

    axios
      .get(metaUrl)
      .then((response) => {
        store.dispatch('meta/updateMeta', response.data);
        next();
      })
      .catch(() => {
        next('/');
      });
  },

  data() {
    return {
      contentLoaded: false,
    };
  },

  computed: {
    ...sync([
      'lang/lang', //
      'general/currentSeason',
      'general/currentSeasonId',
      'general/currentRegionId',
      'general/currentCategoryId',
      'general/currentTeamId',

      'filter/games@completedGamesOnly',
    ]),

    ...mapState({
      team: (state) => state.team.team,
      teamLiked: (state) => state.team.teamLiked,
    }),

    apiParams() {
      return {
        lang: this.lang,
        sid: this.currentSeasonId,
        rid: this.currentRegionId,
        cid: this.currentCategoryId,
        eid: this.currentTeamId,
        completedGamesOnly: this.completedGamesOnly,
      };
    },
  },

  watch: {
    $route(oldRoute, newRoute) {
      if (oldRoute.path !== newRoute.path) {
        this.loadTeam();
      }
    },
  },

  mounted() {
    Bus.$on('refresh_team_following', () => {
      this.getTeamFollowingStatus();
    });

    Bus.$on('refresh', () => {
      this.loadTeam();
    });
  },

  created() {
    this.loadTeam();
  },

  beforeDestroy() {
    Bus.$off('refresh_team_following');
  },

  methods: {
    ...mapActions([
      'getTeam', //
      'getTeamLiked',
    ]),

    async loadTeam() {
      try {
        await this.getTeam({
          params: this.apiParams,
        })
          .then(() => {
            this.contentLoaded = true;

            this.$store.set('general/currentLeagueId', this.team.league.id);
            this.$store.set('general/currentLeagueName', this.team.league.name);

            this.getTeamFollowingStatus();

            // console.log('success loading team!');
            this.$nextTick(() => {
              Bus.$emit('render_chart');
              // Bus.$emit('refresh);
            });
          })
          .catch((err) => {
            if (err.response.data === 'team-not-found') {
              this.$swal({
                title: this.$i18n.t('JSON.team-not-found'),
                showCloseButton: true,
                timer: 5000,
              }).then(() => {
                this.$router.push(this.navigate('/'));
              });
            }
          });
      } catch (error) {
        // error
        // console.log('error loading team!');
      }
    },

    getTeamFollowingStatus() {
      if (this.$auth.check()) {
        this.getTeamLiked({
          params: this.apiParams,
        });
      }
    },
  },
};
</script>
